/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { selectResource, selectVersion } from './configuration.slice';
import { ThunkStatus } from '../../enums/ThunkStatus';
import { ConfigResourceProps } from '../../enums/ConfigResourceProps';
import { getFeesThunk } from './fees.thunk';

/**
 * Get fees configuration from submission-service and stores it in the configuration.slice
 * @returns {{resource, ready: boolean}}
 */
export function useFeesConfiguration() {
  const dispatch = useDispatch();
  const version = useSelector(selectVersion);

  const feesResource = useSelector(state => selectResource(state, ConfigResourceProps.FEE_AMOUNTS_CONFIGURATION));

  useEffect(() => {
    if (version.status === ThunkStatus.SUCCEEDED && feesResource.status === ThunkStatus.IDLE) {
      dispatch(getFeesThunk({ configResource: ConfigResourceProps.FEE_AMOUNTS_CONFIGURATION }));
    }
  }, [version, feesResource]);

  return {
    ready: version.status === ThunkStatus.SUCCEEDED && feesResource.status === ThunkStatus.SUCCEEDED,
    resource: feesResource.value,
  };
}
